import type { IFilterRow, TWiseTableAdvancedFilterOperator } from './types';

/**
 * Stałe szerokości kolumn WiseTable
 *
 * Szerokość kolumny = Math.max(column.size ?? DEFAULT_COLUMN_WIDTH_PX, MIN_COLUMN_WIDTH_PX)
 * - column.size – z konfiguracji kolumny (np. w TraderPanelClientsList)
 * - DEFAULT_COLUMN_WIDTH_PX – gdy kolumna nie ma size (fallback)
 * - MIN_COLUMN_WIDTH_PX – minimum, żeby nagłówki mieściły się w całości (overflow-x na wrapperze)
 *
 * Zwiększ MIN_COLUMN_WIDTH_PX → szersze kolumny, więcej poziomego scrollu.
 * Zmniejsz → węższe kolumny, mniej scrollu, ryzyko ucinania długich nagłówków.
 */
export const DEFAULT_COLUMN_WIDTH_PX = 80;
export const MIN_COLUMN_WIDTH_PX = 150;

export const getEffectiveColumnWidth = (size?: number): number =>
  Math.max(size ?? DEFAULT_COLUMN_WIDTH_PX, MIN_COLUMN_WIDTH_PX);

/** Opcje operatorów porównania w wierszu reguły (bez Oraz/Lub) */
export const ADVANCED_FILTER_OPERATOR_OPTIONS_COMPARISON: {
  value: TWiseTableAdvancedFilterOperator;
  labelKey: string;
}[] = [
  { value: 'eq', labelKey: 'Równe' },
  { value: 'gt', labelKey: 'Większe' },
  { value: 'lt', labelKey: 'Mniejsze' },
  { value: 'contains', labelKey: 'Zawiera' }
];

/** Opcje łącznika między regułami (Oraz / Lub) */
export const LOGICAL_CONNECTOR_OPTIONS: { value: 'and' | 'or'; labelKey: string }[] = [
  { value: 'and', labelKey: 'Oraz' },
  { value: 'or', labelKey: 'Lub' }
];

/** Opcje operatorów w AdvancedFiltersDialog (wszystkie – do etykiet zapisanych filtrów) */
export const ADVANCED_FILTER_OPERATOR_OPTIONS: {
  value: TWiseTableAdvancedFilterOperator;
  labelKey: string;
}[] = [
  ...ADVANCED_FILTER_OPERATOR_OPTIONS_COMPARISON,
  { value: 'and', labelKey: 'Oraz' },
  { value: 'or', labelKey: 'Lub' }
];

/** Etykiety operatorów (do wyświetlania zapisanych filtrów) */
export const ADVANCED_FILTER_OPERATOR_LABELS: Record<TWiseTableAdvancedFilterOperator, string> = {
  eq: 'Równe',
  gt: 'Większe',
  lt: 'Mniejsze',
  contains: 'Zawiera',
  and: 'Oraz',
  or: 'Lub'
};

/** Pusty wiersz formularza filtra */
export const getEmptyFilterRow = (): IFilterRow => ({
  columnFieldSymbol: null,
  operator: null,
  value: '',
  connectorAfter: 'and'
});
